import React from "react";

const HeatMap = () => {
  return (
    <div >
      <div >
  
        {/* SITES Section */}
        <div className="md:mt-2 mt-5">
          <p className="text-[#F38323] font-semibold mb-2 text-[6px] md:text-[20px]">SITES</p>
          <div className='h-[2.5px] bg-black/50'></div>

          <div className="grid md:grid-cols-[300px_repeat(9,1fr)] grid-cols-[90px_repeat(9,1fr)] md:gap-y-4 gap-y-1  md:gap-x-2 gap-x-1 md:mt-3 mt-1">
            {[
              { label: 'Active sites', value: '345' },
              { label: 'Total Sites', value: '2450' },
              { label: 'Women', value: '345' },
              { label: 'Youth', value: '345' },
              { label: 'Members', value: '2450' },
              { label: 'Cooperatives', value: '2450' },
              { label: 'Workers', value: '2450' },
            ].map((item, i) => {
              // Add margin only after row 2 (i=1) and row 4 (i=3)
              const rowGapClass = (i === 1 || i === 3) ? 'mb-3 md:mb-5' : '';
              return (
                <React.Fragment key={i}>
                  <div className={`md:text-[14px] md:w-[215px] text-[6px] text-black ${rowGapClass}`}>
                    {item.label}
                  </div>
                  {[...Array(9)].map((_, j) => (
                    <div
                      key={j}
                      className={`md:h-5 h-4 md:h-[27px] bg-[#CFD7D7] rounded-md text-[5px] md:text-[16px] flex items-center justify-center ${rowGapClass}`}
                    >
                      {item.value}
                    </div>
                  ))}
                </React.Fragment>
              );
            })}
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default HeatMap;
